import PropTypes from 'prop-types';
import React from 'react';
import { Typography } from '@material-ui/core';

export function TabContainer({ children, dir }) {
	return (
		<Typography component="div" dir={dir} style={{ padding: 8 * 2 }}>
			{children}
		</Typography>
	);
}
TabContainer.propTypes = {
	children: PropTypes.node.isRequired,
	dir: PropTypes.string.isRequired,
};
